import { useForm } from "react-hook-form";
import GrayButton from "../../../components/UI/buttonUI/GrayButton";
import DownloadTemplate from "../../../components/common/DownloadTemplate";
import {
  UPDATE_BULK_SITE_TEMPLATE,
  UPDATE_BULK_STATION,
} from "../apiEndpoints";
import UploadFileInput from "../../../components/UI/PageInput/UploadFileInput";
import PrimaryButton from "../../../components/UI/buttonUI/PrimaryButton";
import UpdateBulkSiteSuccess from "../forms/updateSite/UpdateBulkSiteSuccess";
import MainPageLayout from "../../../layout/MainPageLayout";
import CenteredHeading from "../../../components/UI/headingsUI/CenteredHeading";
import useUploadSheet from "../../../CustomHooks/useAxios/useUploadSheet";
import UpdateSiteSheetError from "../forms/updateSite/UpdateSiteSheetError";
import ErrorDisplay from "../../../components/UI/ErrorDisplay";
import { Download } from "lucide-react";

const UpdateBulkSIte = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: {
      sheet: undefined,
    },
  });
  const {
    executePost,
    loading,
    isSucceed,
    formError,
    formErrMsg,
    responseData,
    setFormError,
    errorResponse,
  } = useUploadSheet();
  const sheet = watch("sheet");

  const onSubmit = async (data) => {
    // send data into form data
    const formData = new FormData();
    formData.append("sheet", data.sheet[0]);
    //API calling
    executePost(formData, UPDATE_BULK_STATION, reset);
  };

  return (
    <MainPageLayout headerConfig={{ title: "Update Bulk Site" }}>
      <div className="form-container">
        <CenteredHeading title="Update Bulk Sites" />
        {formError &&
          (Array.isArray(errorResponse) ? (
            <UpdateSiteSheetError
              errorList={errorResponse}
              closeAction={() => setFormError(false)}
            />
          ) : (
            <ErrorDisplay
              message={formErrMsg}
              closeAction={() => setFormError(false)}
            />
          ))}
        <div className="form-border max-w-5xl mx-auto w-95% form-border">
          <div className="flex justify-between">
            <p className="text-dg2">
              {sheet && sheet[0]?.name ? "Uploaded" : "Upload"} File
            </p>
            <DownloadTemplate
              apiEndPoint={UPDATE_BULK_SITE_TEMPLATE}
              downloadFileName="update_station_bulk_upload"
            />
          </div>
          <form
            onSubmit={!loading ? (e) => handleSubmit(onSubmit)(e) : undefined}
          >
            <UploadFileInput
              name="sheet"
              placeholder=".xlsx"
              accept=".xlsx, file/xlsx"
              register={{
                ...register("sheet", {
                  required: "Please choose a file",
                }),
              }}
              setValue={setValue}
              multiple={true}
              error={errors.sheet}
              uploadedFile={sheet}
              removeUploadedFile={() => setValue("sheet", "")}
            />
            <div className="sheet-upload-btn-wrap">
              <PrimaryButton
                btnText={!loading ? "Upload Sheet" : "Adding..."}
                loading={loading}
                Icon={Download}
                size={20}
              />
              <GrayButton
                btnText="Clear"
                width="w-40"
                onClick={() => reset()}
              />
            </div>
          </form>
          {isSucceed && <UpdateBulkSiteSuccess viewDetails={responseData} />}
        </div>
      </div>
    </MainPageLayout>
  );
};

export default UpdateBulkSIte;
